export default __webpack_public_path__ + "static/media/037-anchor.a0fc65de.png";